// extracted by mini-css-extract-plugin
export default {"footer":"MultifactorAuthenticationAdminDeactivationPopup_footer__hvPxF"};